import { shape, string, bool, array } from 'prop-types';

export const sideMenuLink = shape({
  key: string.isRequired,
  title: string.isRequired,
  link: string.isRequired,
  options: shape({
    exact: bool,
  }),
  children: array,
});
